module.exports = __webpack_public_path__ + "static/img/monitor03.fb2e23f8.png";